import React from 'react';
import { func, node } from 'prop-types';
import styles from './styles.scss';
import ArrowLeft from '../../../Icons/dist/components/ArrowLeft';

var BackLink = function BackLink(_ref) {
  var onBackHandler = _ref.onBackHandler,
      children = _ref.children;
  return React.createElement(
    'a',
    { className: styles.backLink, onClick: onBackHandler, 'data-hook': 'menu-navigation-back-link' },
    React.createElement(
      'span',
      { className: styles.backArrow },
      React.createElement(ArrowLeft, null)
    ),
    React.createElement(
      'span',
      null,
      children
    )
  );
};

BackLink.propTypes = {
  onBackHandler: func,
  children: node
};

export default BackLink;
//# sourceMappingURL=BackLink.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/navigation/BackLink.js